import { render, staticRenderFns } from "./apago.vue?vue&type=template&id=6af93912"
import script from "./apago.vue?vue&type=script&lang=js"
export * from "./apago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports